// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"a27f11c4","442":"aa347aa0","650":"809ffe78","787":"a542a446","808":"b87c6360"}[chunkId] + ".chunk.js";
};